/** @format */

const template = `
<span class="tiny-badge" ng-class="ctrl.badgeClass">{{'STUDENT_APPLICATIONS.STATE.' + ctrl.state | translate}}</span>
`;
export default template;
